import { z } from 'zod';
import { $getFiltersRequestType } from '@shared/types';

const $ScheduleWork = z.object({
  id: z.number(),
  name: z.string(),
});

export type GetScheduleWorkRequest = z.infer<typeof $GetScheduleWorkRequest>;
export const $GetScheduleWorkRequest = $getFiltersRequestType(z.object({}));

export const $GetScheduleWorksResponse = z.array($ScheduleWork);

export type GetScheduleWorksResponse = z.infer<
  typeof $GetScheduleWorksResponse
>;
